import { createContext, useContext } from "react";
import type { Enquiry } from "../types/enquiry.types";

interface EnquiryOverviewContextType {
  enquiry: Enquiry | null;
  refetch: () => Promise<void>;
}

const EnquiryOverviewContext = createContext<EnquiryOverviewContextType | null>(
  null,
);

export const useEnquiryOverview = () => {
  const context = useContext(EnquiryOverviewContext);
  if (!context) {
    throw new Error("useEnquiryOverview must be used within provider");
  }
  return context;
};

export default EnquiryOverviewContext;
